import packingOptions from "./packingOptions";

const state = {
  url: "",
  image: [],
  td_texture: { "1": "0.1" },
  id: "preview3DPacking",
  current_td_data: null,
  activePreview: "preview3D",
  preview_3dloading: false
};

const getters = {
  getPreview3DLoading: state => {
    return state.preview_3dloading;
  },
  getPreview3D: state => {
    return state.url;
  },
  get3DPreviewId: state => {
    return state.id;
  },
  getImageTd: state => {
    return state.image;
  },
  getCurrentTdData: state => {
    return state.current_td_data;
  },
  getTdTexture: (state, getters) => {
    if (getters.getPackingTdTexturesFromTemplateMapping)
      return getters.getPackingTdTexturesFromTemplateMapping;
    if (getters.getPackingTdTextures) return getters.getPackingTdTextures;
    return state.td_texture;
  },
  getActivePreview: state => {
    return state.activePreview;
  }
};

const mutations = {
  setPreview3D: (state, payload) => {
    state.url = payload;
  },
  setPreview3DImage: (state, payload) => {
    state.image = payload;
  },
  setPreview3DTexture: (state, payload) => {
    state.td_texture = payload;
  },
  setCurrentTdData: (state, payload) => {
    state.current_td_data = payload;
  },
  setActivePreview: (state, payload) => {
    state.activePreview = payload;
  },
  setPreview3DLoading: (state, payload) => {
    state.preview_3dloading = payload;
  }
};

const actions = {
  setPreview3DLoading: ({ commit }, payload) => {
    commit("setPreview3DLoading", payload);
  },
  setActivePreview: ({ commit }, payload) => {
    commit("setActivePreview", payload);
  },
  setPreview3D: ({ commit }, payload) => {
    commit("setPreview3D", payload);
  },
  setPreview3DImage: ({ commit, getters, dispatch }, payload) => {
    commit("setPreview3DImage", payload);
    dispatch("setTdImage");
  },
  setTdImage: ({ commit, getters }, payload) => {
    var packingOptions = getters.getPackingOptionsData;
    var infos_td = {};
    if (packingOptions.insideTexture) {
      infos_td["insideTexture"] = packingOptions.insideTexture;
    }
    if (packingOptions.outsideTexture) {
      infos_td["outsideTexture"] = packingOptions.outsideTexture;
    }
    if (packingOptions.papercolor) {
      infos_td["papercolor"] = packingOptions.papercolor;
    }
    commit("setCurrentTdData", getters.getTdTexture);
    if (jQuery("#" + getters.get3DPreviewId + " iframe").length) {
      jQuery("#" + getters.get3DPreviewId + " iframe")
        .get(0)
        .contentWindow.postMessage(
          JSON.stringify({
            texture_upload: getters.getTdTexture,
            image: getters.getImageTd,
            infos_td: infos_td
          }),
          "*"
        );
    }
  },
  setPreview3DTexture: ({ commit }, payload) => {
    commit("setPreview3DTexture", payload);
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
